'use client'

import {
  EQUITY_BACKED_AUDIT_EMPTY,
  EQUITY_BACKED_AUDIT_TITLE,
} from '@domain/pre-ipo-access/prototypeSharedCopy'
import { Dialog, DialogContent } from '@components/shared/dialog'

type EquityAuditDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  auditUrl?: string | null
}

function normalizeAuditHref(value: string) {
  const trimmed = value.trim()
  if (!trimmed) return undefined
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  return `https://${trimmed}`
}

export function EquityAuditDialog({
  open,
  onOpenChange,
  auditUrl,
}: EquityAuditDialogProps) {
  const publishedHref = auditUrl ? normalizeAuditHref(auditUrl) : undefined
  const embedSrc = publishedHref
    ? `/api/equity-audit-preview?src=${encodeURIComponent(publishedHref)}#view=Fit&navpanes=0`
    : undefined

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        title={EQUITY_BACKED_AUDIT_TITLE}
        hideTitle
        portalClassName="items-center"
        closeButtonClassName="!right-2 !top-2"
        className="mt-0 flex h-[92dvh] max-h-[92dvh] w-[calc(100vw-1rem)] max-w-[calc(100vw-1rem)] flex-col rounded-2xl border border-pp-surface-border bg-white p-2 xs:mt-0 xs:max-w-[calc(100vw-1rem)] xs:p-2 sm:w-[min(48rem,55vw)] sm:max-w-[min(48rem,55vw)] sm:rounded-4xl"
        childrenClassName="flex min-h-0 max-h-none flex-1 flex-col overflow-hidden"
      >
        {embedSrc ? (
          <iframe
            src={embedSrc}
            title={EQUITY_BACKED_AUDIT_TITLE}
            className="h-full min-h-0 w-full flex-1 rounded-xl border border-pp-surface-border bg-white"
          />
        ) : (
          <p className="mt-4 font-montserrat text-sm leading-relaxed text-pp-content-secondary normal-case sm:text-[0.9375rem]">
            {EQUITY_BACKED_AUDIT_EMPTY}
          </p>
        )}
      </DialogContent>
    </Dialog>
  )
}
